import { render, staticRenderFns } from "./SessionsListCreateProject.vue?vue&type=template&id=597a98f6&scoped=true&"
import script from "./SessionsListCreateProject.vue?vue&type=script&lang=js&"
export * from "./SessionsListCreateProject.vue?vue&type=script&lang=js&"
import style0 from "./SessionsListCreateProject.vue?vue&type=style&index=0&id=597a98f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597a98f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCol,VIcon,VRow,VTooltip})
